import createAction from '../actionCreator';

const action = createAction('session');

export const STORE_SESSION = action('STORE_SESSION');
export const LOGIN = action('LOGIN');
export const LOGOUT = action('LOGOUT');
export const GET_CURRENT_USER = action('GET_CURRENT_USER');
